import { jsx as i } from "react/jsx-runtime";
import { Tooltip as m, PopoverInteractionKind as N } from "@blueprintjs/core";
import t from "classnames";
import "./main.scss";
const d = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  DEFAULT: "DEFAULT"
}, e = ({
  children: p,
  content: s = void 0,
  intent: o = void 0,
  className: r,
  popoverClassName: a,
  hoverOpenDelay: l = 150
}) => /* @__PURE__ */ i(
  m,
  {
    content: s !== null ? s : void 0,
    className: t(r, "sds_tooltip__target"),
    hoverOpenDelay: l,
    interactionKind: N.HOVER,
    portalClassName: "sds_tooltip__portal",
    popoverClassName: t(
      "sds_tooltip",
      {
        [`sds_tooltip--${o == null ? void 0 : o.toLowerCase()}`]: o
      },
      a
    ),
    children: p
  }
);
e.Intent = d;
export {
  e as Tooltip
};
//# sourceMappingURL=index.js.map
